import Dashboard from "Components/Dashboard";
import Topology from "Components/Topology";
import Upgrade from "Components/DeviceBackup";
import Report from "Components/Report";
import Management from "Components/Management";
import Maintenance from "Components/Maintenance";
import {
  SettingFilled,
  PieChartFilled,
  AreaChartOutlined,
  ClusterOutlined,
  CloudDownloadOutlined,
  ToolFilled,
} from "@ant-design/icons";
import { SiOpenapiinitiative } from "react-icons/si";

const proxyIP = require("../../../package.json");

const OpenAPI = process.env.NODE_ENV === "development" ? proxyIP?.proxy : window?.OpenAPI_IP;

const dashboard = {
  title: "Dashboard",
  path: "/",
  icon: <PieChartFilled style={{ fontSize: "1.5rem" }} />,
  level: ["super", "super_super", "admin", "set", "get"],
  component: Dashboard,
};
const overview = {
  title: "Overview",
  path: "/overview",
  icon: <ClusterOutlined style={{ fontSize: "1.5rem" }} />,
  level: ["super", "super_super", "admin", "set", "get"],
  component: Topology,
};

const upgrade = {
  title: "Upgrade",
  path: "/upgrade",
  icon: <CloudDownloadOutlined style={{ fontSize: "1.5rem" }} />,
  level: ["super", "super_super", "admin", "set"],
  component: Upgrade,
};

const report = {
  title: "Report",
  path: "/report",
  icon: <AreaChartOutlined style={{ fontSize: "1.5rem" }} />,
  level: ["super", "super_super", "admin", "set", "get"],
  component: Report,
};

const maintenance = {
  title: "Maintenance",
  path: "/maintenance",
  icon: <ToolFilled style={{ fontSize: "1.5rem" }} />,
  level: ["super", "super_super", "admin"],
  component: Maintenance,
};

const management = {
  title: "Management",
  path: "/management",
  icon: <SettingFilled style={{ fontSize: "1.5rem" }} />,
  level: ["super", "super_super", "admin"],
  component: Management,
};

const openAPI = {
  title: "OpenAPI",
  path: `${OpenAPI}/docs`,
  icon: (
    <span role="img" className="anticon anticon-setting ant-menu-item-icon" style={{ fontSize: "1.5rem" }}>
      <SiOpenapiinitiative />
    </span>
  ),
  level: ["super", "super_super"],
  component: () => <></>,
};
// 將這些 路由配置物件 導入 NavRoutes 這個陣列當中，並 導出給 App.tsx 組件使用
export const NavRoutes = [dashboard, overview, upgrade, report, maintenance, management, openAPI];
